<script setup>
import { computed, ref, onBeforeMount, watch, getCurrentInstance } from 'vue'
import _ from 'lodash'
import { useNotification } from "@kyvg/vue3-notification"
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import draggable from 'vuedraggable'
import PlaylistService from "@/services/Playlistservice"
import IconBase from '@/components/icon/IconBase.vue'
import IconFilm from '@/components/icon/IconFilm.vue'
import IconCamera from '@/components/icon/IconCamera.vue'
import IconHandleVertical from '@/components/icon/IconHandleVertical.vue'
import FormButton from '../Atoms/FormButton.vue'
import IconPlus from '../icon/IconPlus.vue'
import IconBin from '../icon/IconBin.vue'


const { notify } = useNotification()
const instance = getCurrentInstance()
const root = instance.proxy.$root
const route = useRoute()
const store = useStore()

// Emits
const emit = defineEmits(['add-item'])

// Computed
const currentPlaylist = computed(() => store.getters['Playlist/currentPlaylist'])


const streamsComputed = computed({
  get() {
    return currentPlaylist.value.streams
  },
  set(newOrder) {
    // Only persist when the order actually changed; draggable re-syncs on
    // store refreshes and must not trigger another save (infinite PUT loop)
    const currentIds = currentPlaylist.value.streams.map(s => s.id).join(',')
    const newIds = newOrder.map(s => s.id).join(',')
    if (currentIds === newIds) return
    reorderStreams(newOrder)
  }
})

// Hooks
onBeforeMount(() => {

})

// Methods
const reorderStreams = async (streamArray) => {
  await PlaylistService.updatePlaylist(currentPlaylist.value.name, streamArray, currentPlaylist.value._id)
  await store.dispatch('Playlist/getPlaylist', true)
}

const removeItem = (stream) => {
  const streamArray = _.cloneDeep(currentPlaylist.value.streams.filter((s) => {
    return s.id != stream.id
  }))

  addToplaylist(streamArray)
}

const addToplaylist = async (streamArray, back = false) => {
  await PlaylistService.updatePlaylist(currentPlaylist.value.name, streamArray, currentPlaylist.value._id)
  await store.dispatch('Playlist/getPlaylist', true)
}

const addItem = () => {
  emit('add-item')
}
</script>
<template>
  <div class="">
    <div class="bg-surface-2 !rounded-lg !mt-4" v-if="currentPlaylist?.streams.length > 0">
      <div class="flex items-center gap-x-4  bg-surface-3 rounded-t-lg !px-3 !py-2">
        <h3 class="text-surface-7 font-medium text-tiny basis-12">#</h3>
        <h3 class="text-surface-7 font-medium text-tiny">Source</h3>
      </div>

      <draggable
        class="playlist-table-list divide-y divide-surface-4 max-h-80 lg:max-h-[calc(100vh-240px)] overflow-y-auto touch-pan-y"
        :model-value="streamsComputed"
        @update:model-value="streamsComputed = $event"
        tag="ul"
        :item-key="(item) => item.id"
        handle=".playlist-drag-handle"
        :delay="150"
        :delay-on-touch-only="true"
      >
        <template #item="{ element, index }">
          <li class="flex items-center gap-x-4 h-12 !px-3">
            <IconBase class="playlist-drag-handle cursor-grab active:cursor-grabbing basis-4 text-surface-7 shrink-0 touch-none">
              <IconHandle-vertical />
            </IconBase>
            <span class="basis-4 text-surface-text-1 text-tiny">{{ index + 1 }}</span>
            <IconBase class="text-surface-text-1 shrink-0">
                <IconCamera v-if="element.type === 'live'" />
                <IconFilm v-else />
              </IconBase>
            <span :title="element.name"
              class="text-tiny text-surface-text-1 max-w-[55%] md:max-w-[70%] xl:max-w-[82%] truncate">
              
              {{ element.name }}
            </span>

            <FormButton class="ml-auto shrink-0" isIcon type="link" size="sm" @click="removeItem(element)">
              <IconBase>
                <IconBin />
              </IconBase>
            </FormButton>
          </li>
        </template>
      </draggable>
    </div>
    <div class="flex lg:h-full" v-else>
      <div
        class="flex flex-col items-center justify-center !border border-dashed !border-surface-3 rounded-xl p-4 w-full lg:h-full">
        
        <p class="text-base text-surface-text-2">No source added</p>
        <p class="text-xs text-surface-8 !mb-4">Select a Livestream or VOD to add to the list.</p>
        <FormButton type="main" @click="addItem">
          <IconBase>
            <IconPlus />
          </IconBase>
          Add content
        </FormButton>
      </div>
    </div>
  </div>
</template>